import {ThemeColorPath} from 'platform/foundation';

import {isNil} from 'ramda';

import {BRANCH_BADGE_COLORS, BRANCH_BADGE_FALLBACK_COLOR} from '../../../constants/BRANCH_BADGE';

const HASH_SEED = 7;
const HASH_MULTIPLIER = 31;
const HASH_MODULO = 1_000_003;

/**
 * Derived from the branch id, never from rank or row order: the badge is an identity
 * marker, so a branch keeps its colour across period switches, reloads and new branches
 * opening. Two branches may land on the same hue — the code text stays the identifier.
 */
export function getBranchBadgeColor(branchId: string): ThemeColorPath {
  const hash = Array.from(branchId).reduce(
    (accumulator, character) =>
      (accumulator * HASH_MULTIPLIER + character.charCodeAt(0)) % HASH_MODULO,
    HASH_SEED
  );

  const color = BRANCH_BADGE_COLORS.at(hash % BRANCH_BADGE_COLORS.length);

  return isNil(color) ? BRANCH_BADGE_FALLBACK_COLOR : color;
}
